import memoize from 'memoize-one';

import { GlobalTransitionPreloader } from './GlobalTransitionPreloader.ts';

export const getGlobalTransitionPreloader = memoize(() => {
	return new GlobalTransitionPreloader();
});
